/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="m11.4102 9.7279-3.1899 3.1898a1.011 1.011 0 0 0-.0375.0441l-.003.0038-.01.0129c-.577.7536.4483 1.7419 1.1138 1.0025l1.8988-1.8987v5.0126c0 .9874 1.5189.9874 1.5189 0v-5.0126l1.8988 1.8987c.7595.7595 1.8228-.3038 1.1392-1.0633l-3.2658-3.1898a.8613.8613 0 0 0-.0586-.0534c-.2815-.2327-.6646-.2327-.9461 0a.8613.8613 0 0 0-.0586.0534Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5 2.5c3.68 0 6.741 2.6504 7.3782 6.1464C21.806 9.2785 24 11.883 24 15c0 3.5898-2.9102 6.5-6.5 6.5h-12C2.4625 21.5 0 19.0376 0 16c0-2.5292 1.7071-4.6596 4.032-5.3019A7.5861 7.5861 0 0 1 4 10c0-4.1421 3.3579-7.5 7.5-7.5Zm-7.0685 9.6439 1.2097-.3342-.1155-1.2496A6.0837 6.0837 0 0 1 5.5 10c0-3.3137 2.6863-6 6-6 2.9424 0 5.3929 2.1195 5.9025 4.9154l.1797.9857.9794.2115C20.8134 10.5988 22.5 12.6042 22.5 15c0 2.7614-2.2386 5-5 5h-12c-2.2091 0-4-1.7909-4-4 0-1.8373 1.24-3.3888 2.9315-3.8561Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'CloudUpload'
);
